export enum UserOptionSettings {
	AcceptData = 155,
	GoogleAnalytics = 152,
	VideoAnalytics = 154,
}
